import {fetchExceptionShipments} from "../network/PackageListAPI";

export const PackageListReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_DATA":
            const {dispatcher} = action.data;
            fetchExceptionShipments(dispatcher);
            return {...state, loading: true, success: true};
        case "SET_DATA":
            return {...state, packages: action.data, loading: false, success: true};
        case "SET_ERROR":
            return {...state, loading: false, success: false};
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/transferSheet/reducers/PackageListReducer.js